/**
 * i18n phase: independent user delivery-address book (UserAddressBookPage,
 * UserAddressSearchPage, UserAddressEditModal). Tuples are [ko, en, vi, ru].
 */

const book = {
  title: ['주소 관리', 'Manage addresses', 'Quản lý địa chỉ', 'Управление адресами'],
  addNew: ['+ 새 주소 추가', '+ Add new address', '+ Thêm địa chỉ mới', '+ Добавить новый адрес'],
  loading: ['불러오는 중…', 'Loading…', 'Đang tải…', 'Загрузка…'],
  emptyTitle: ['저장된 주소가 없어요', 'No saved addresses', 'Chưa có địa chỉ đã lưu', 'Нет сохранённых адресов'],
  emptyHint: [
    '배달 받을 주소를 추가해 두면 주문할 때 바로 쓸 수 있어요',
    'Add a delivery address to use it instantly when ordering',
    'Thêm địa chỉ giao hàng để dùng ngay khi đặt hàng',
    'Добавьте адрес доставки, чтобы использовать его при заказе',
  ],
  addCta: ['주소 추가하기', 'Add address', 'Thêm địa chỉ', 'Добавить адрес'],
  defaultBadge: ['기본', 'Default', 'Mặc định', 'Основной'],
  editAria: ['수정', 'Edit', 'Sửa', 'Изменить'],
  deleteAria: ['삭제', 'Delete', 'Xóa', 'Удалить'],
  deleteConfirm: ['이 주소를 삭제할까요?', 'Delete this address?', 'Xóa địa chỉ này?', 'Удалить этот адрес?'],
  setDefaultSuccess: [
    '기본 주소로 설정했어요',
    'Set as default address',
    'Đã đặt làm địa chỉ mặc định',
    'Установлен как основной адрес',
  ],
  setDefaultFail: ['설정에 실패했어요', 'Failed to update', 'Cập nhật thất bại', 'Не удалось обновить'],
  deleteSuccess: ['주소를 삭제했어요', 'Address deleted', 'Đã xóa địa chỉ', 'Адрес удалён'],
  deleteFail: ['삭제에 실패했어요', 'Failed to delete', 'Xóa thất bại', 'Не удалось удалить'],
  untitled: ['주소', 'Address', 'Địa chỉ', 'Адрес'],
};

const search = {
  title: ['주소 검색', 'Search address', 'Tìm địa chỉ', 'Поиск адреса'],
  heading: [
    '주소를 검색해주세요',
    'Search for your address',
    'Vui lòng tìm địa chỉ của bạn',
    'Введите адрес для поиска',
  ],
  placeholder: [
    '도로명, 건물명 등으로 검색',
    'Search by street, building name, etc.',
    'Tìm theo tên đường, tòa nhà...',
    'Поиск по улице, названию здания…',
  ],
  currentLocation: [
    '현재 위치로 찾기',
    'Use current location',
    'Dùng vị trí hiện tại',
    'Использовать текущее местоположение',
  ],
  locating: ['위치 확인 중…', 'Getting location…', 'Đang lấy vị trí…', 'Определение местоположения…'],
  searching: ['검색 중…', 'Searching…', 'Đang tìm…', 'Поиск…'],
  noResults: [
    '검색 결과가 없어요. 다른 키워드로 시도해 보세요.',
    'No results found. Try a different keyword.',
    'Không có kết quả. Hãy thử từ khóa khác.',
    'Ничего не найдено. Попробуйте другой запрос.',
  ],
  searchFail: [
    '검색에 실패했어요. 잠시 후 다시 시도해 주세요.',
    'Search failed. Please try again.',
    'Tìm kiếm thất bại. Vui lòng thử lại sau.',
    'Ошибка поиска. Попробуйте позже.',
  ],
  resolveFail: [
    '주소 정보를 가져오지 못했어요. 다시 시도해 주세요',
    'Could not get address details. Please try again',
    'Không lấy được thông tin địa chỉ. Vui lòng thử lại',
    'Не удалось получить данные адреса. Попробуйте снова',
  ],
  geoUnsupported: [
    '이 기기에서는 위치 확인을 지원하지 않아요',
    'This device does not support location',
    'Thiết bị này không hỗ trợ định vị',
    'Устройство не поддерживает геолокацию',
  ],
  geoDenied: [
    '위치 확인을 허용해주셔야 현재 위치로 찾을 수 있어요',
    'Allow location access to use your current location',
    'Vui lòng cho phép truy cập vị trí để dùng vị trí hiện tại',
    'Разрешите доступ к геолокации, чтобы использовать текущее местоположение',
  ],
  geoDeniedSettings: [
    '이전에 위치 접근을 거부하셨어요. 휴대폰 설정 > 브라우저(또는 이 앱) > 위치에서 허용으로 바꿔주세요',
    "You've previously denied location access. Change it to Allow in your phone Settings > Browser (or this app) > Location",
    'Bạn đã từ chối quyền truy cập vị trí trước đó. Vui lòng vào Cài đặt điện thoại > Trình duyệt (hoặc ứng dụng này) > Vị trí để cho phép',
    'Вы ранее отклонили доступ к геолокации. Измените на "Разрешить" в Настройках телефона > Браузер (или это приложение) > Местоположение',
  ],
  resolving: ['확인 중…', 'Checking…', 'Đang kiểm tra…', 'Проверка…'],
  tipsTitle: [
    '이렇게 검색해 보세요',
    'Try searching like this',
    'Hãy thử tìm như thế này',
    'Попробуйте искать так',
  ],
  tipRoad: [
    '도로명 + 건물번호 (예: Bạch Đằng 76)',
    'Street name + building number (e.g. Bạch Đằng 76)',
    'Tên đường + số nhà (vd: Bạch Đằng 76)',
    'Название улицы + номер дома (напр. Bạch Đằng 76)',
  ],
  tipBuilding: [
    '건물명 + 지역 (예: Vincom Plaza, 하이쩌우)',
    'Building name + area (e.g. Vincom Plaza, Hai Chau)',
    'Tên tòa nhà + khu vực (vd: Vincom Plaza, Hải Châu)',
    'Название здания + район (напр. Vincom Plaza, Хай Тяу)',
  ],
  tipApt: [
    '아파트명 (예: 무엉타인 럭셔리)',
    'Apartment name (e.g. Muong Thanh Luxury)',
    'Tên chung cư (vd: Mường Thanh Luxury)',
    'Название ЖК (напр. Muong Thanh Luxury)',
  ],
  researchAgain: ['다시 검색', 'Search again', 'Tìm lại', 'Искать снова'],
  mapPinHint: [
    '핀을 눌러서 정확한 위치로 옮겨보세요',
    'Drag the pin to the exact location',
    'Kéo ghim đến đúng vị trí',
    'Перетащите метку в точное место',
  ],
  detailLabel: [
    '상세주소 (선택)',
    'Detail address (optional)',
    'Địa chỉ chi tiết (tùy chọn)',
    'Подробный адрес (необязательно)',
  ],
  detailPlaceholder: [
    '예: OO아파트 12층 1201호',
    'e.g. Building name, floor, unit 1201',
    'vd: Tòa nhà, tầng 12, phòng 1201',
    'напр. здание, этаж 12, кв. 1201',
  ],
  labelSectionTitle: ['라벨', 'Label', 'Nhãn', 'Метка'],
  labelHome: ['집', 'Home', 'Nhà', 'Дом'],
  labelWork: ['회사', 'Work', 'Công ty', 'Работа'],
  labelOther: ['기타', 'Other', 'Khác', 'Другое'],
  labelOtherPlaceholder: [
    '라벨 직접 입력',
    'Enter custom label',
    'Nhập nhãn tùy chỉnh',
    'Введите свою метку',
  ],
  setDefaultCheckbox: [
    '기본 주소로 설정',
    'Set as default address',
    'Đặt làm địa chỉ mặc định',
    'Сделать основным адресом',
  ],
  saveMissingAddress: [
    '주소를 다시 선택해 주세요',
    'Please select an address again',
    'Vui lòng chọn lại địa chỉ',
    'Пожалуйста, выберите адрес заново',
  ],
  saveSuccess: ['주소를 저장했어요', 'Address saved', 'Đã lưu địa chỉ', 'Адрес сохранён'],
  saveFail: ['저장에 실패했어요', 'Failed to save', 'Lưu thất bại', 'Не удалось сохранить'],
  saveBtn: ['저장', 'Save', 'Lưu', 'Сохранить'],
  savingBtn: ['저장 중…', 'Saving…', 'Đang lưu…', 'Сохранение…'],
};

const edit = {
  title: ['주소 수정', 'Edit address', 'Sửa địa chỉ', 'Изменить адрес'],
  close: ['닫기', 'Close', 'Đóng', 'Закрыть'],
  labelLabel: ['라벨', 'Label', 'Nhãn', 'Метка'],
  labelPlaceholder: ['예: 집, 회사', 'e.g. Home, Work', 'vd: Nhà, Công ty', 'напр. Дом, Работа'],
  detailLabel: ['상세주소', 'Detail address', 'Địa chỉ chi tiết', 'Подробный адрес'],
  detailPlaceholder: [
    '예: OO아파트 12층 1201호',
    'e.g. Building name, floor, unit 1201',
    'vd: Tòa nhà, tầng 12, phòng 1201',
    'напр. здание, этаж 12, кв. 1201',
  ],
  cancel: ['취소', 'Cancel', 'Hủy', 'Отмена'],
  save: ['저장', 'Save', 'Lưu', 'Сохранить'],
  saving: ['저장 중…', 'Saving…', 'Đang lưu…', 'Сохранение…'],
  updateSuccess: ['주소를 수정했어요', 'Address updated', 'Đã cập nhật địa chỉ', 'Адрес обновлён'],
  updateFail: ['수정에 실패했어요', 'Failed to update', 'Cập nhật thất bại', 'Не удалось обновить'],
};

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, v]) => {
    if (Array.isArray(v) && v.length >= 4) out[k] = v[langIndex];
    else if (v && typeof v === 'object' && !Array.isArray(v)) out[k] = pick(v, langIndex);
    else out[k] = v;
  });
  return out;
}

function buildLang(langIndex) {
  return {
    userAddress: {
      book: pick(book, langIndex),
      search: pick(search, langIndex),
      edit: pick(edit, langIndex),
    },
  };
}

export const phaseUserAddressBookKo = buildLang(0);
export const phaseUserAddressBookEn = buildLang(1);
export const phaseUserAddressBookVi = buildLang(2);
export const phaseUserAddressBookRu = buildLang(3);
